export default {
      id: "icon-bool-exclude-usage",
      viewBox: "0 0 17 15",
      url: "/" + "assets/sprite.svg#icon-bool-exclude",
      toString: function () {
        return this.url;
      }
    }